/* eslint-disable import/extensions */
import {type Inventory} from '@unbrs/plastic-data';
import {getInventories} from '../../feeds';
import {BrsBaseWidget} from '../base';
import html from './views/idashboard.tmpl.html';
import {BrsInventories} from './inventories';
import {BrsPlasticInventoryMapWidget} from './imap';

BrsBaseWidget.registerBrsWidget(BrsInventories);
BrsBaseWidget.registerBrsWidget(BrsPlasticInventoryMapWidget);

type BrsInventoryDashboardOptions = {
	geojson?: GeoJSON.FeatureCollection;
	resourceUrl: string;
};

export class BrsInventoryDashboard extends kendo.ui.Widget {
	private readonly woptions: BrsInventoryDashboardOptions;

	constructor(selector: Element, options?: BrsInventoryDashboardOptions) {
		super(selector, options);
		const defaultOptions: BrsInventoryDashboardOptions = {
			resourceUrl: '',
		};
		this.woptions = {...defaultOptions, ...options};
		$(this.element).html(html);
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		this.onInit();
	}

	async onInit() {
		const inventoryDS = this.getInventoryDataSource();
		$('#brs-inventories-map', this.element).kendoBrsPlasticInventoryMapWidget(
			{
				dataSource: inventoryDS,
				geojson: this.woptions.geojson,
			},
		);

		$('#brs-inventories-list', this.element).kendoBrsInventories({
			dataSource: inventoryDS,
		});

		inventoryDS.bind('change', (event: kendo.data.DataSourceChangeEvent) => {
			console.log(event);
		});

		const viewModel = kendo.observable({
			onCollapsePanel(event: kendo.ui.PanelBarExpandEvent) {
				if (event.item) {
					$(event.item).find('>span').removeClass('k-selected');
				}
			},
		});
		const geojson = this.woptions.geojson;
		if (geojson) {
			const countriesDataSource: Array<{name: string; id: string}> = [];
			for (const feature of geojson.features) {
				if (feature.properties?.['name'] && feature.properties['id']) {
					countriesDataSource.push({
						name: feature.properties['name'] as string,
						id: feature.properties['id'] as string,
					});
				}
			}

			countriesDataSource.sort((a, b) => a.name.localeCompare(b.name));

			$('#brs-inventory-map-zoom-in').kendoDropDownList({
				dataSource: countriesDataSource,
				dataTextField: 'name',
				dataValueField: 'id',
				optionLabel: 'Zoom to country...',
				change(event: kendo.ui.DropDownListChangeEvent) {
					const map = $('#brs-inventories-map').data('kendoBrsPlasticInventoryMapWidget');
					map.zoomToCountry(event.sender.value());
					event.sender.value('');
				},
			});
		}

		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		inventoryDS.fetch();
		kendo.bind(this.element, viewModel);
	}

	getInventoryDataSource(): kendo.data.DataSource {
		const resourceUrl = this.woptions.resourceUrl;
		return new kendo.data.DataSource({
			transport: {
				async read(options) {
					const result: Inventory.InventoryData[] = await getInventories(resourceUrl);
					options.success(result);
				},
			},
		});
	}
}

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface JQuery {
		kendoBrsInventoryDashboard(options?: BrsInventoryDashboardOptions): JQuery;
	}
}
